import React from 'react';

import s from './style.module.css';

type Heading2Props = {
    title: string;
    id?: string;
    fontWeight?: number;
};

const DEFAULT_FONT_WIDTH = 400;

export const Heading2 = (props: Heading2Props) => {
    const fontWeight = props.fontWeight ? props.fontWeight : DEFAULT_FONT_WIDTH;

    return (
        <h2 id={props.id} className={s.heading} style={{ fontWeight: fontWeight }}>
            {props.title}
        </h2>
    );
};
export default Heading2;
